module.exports = __webpack_public_path__ + "fb4cddb8f5a1a3dfc4dae6263c0b0cfa.svg";